import React from "react";
import { ReactSVG } from "react-svg";
import { IoImageOutline } from "react-icons/io5";
//import { Document, Page, pdfjs } from "react-pdf/dist/esm/entry.webpack5";
import { Document, Page, pdfjs } from "react-pdf";
import { Lazy } from "@/components/Lazy";
import { checkValidURL, formatClientUrl } from "@/utils/formHelper";
import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { QREditorContext } from "@/contexts/QREditorContext";
import { isClient } from "@/utils/browser";
import { PreviewLayout } from ".";
import { Typography } from "../Typography";
import { Button } from "../Button";


import "./styles.scss";

export default function PreviewPdf(props: QRProps<"pdf">) {
  const qrEditorContext = React.useContext<QREditorContextProps<"pdf">>(QREditorContext);
  const data = props?.data || qrEditorContext?.qrData.data;
  const SHOW_MODAL_WIDTH = 888;

  const isInitPreview = props?.initPreview;

  const downloadPDF = () => {
    const downloadLink = document.createElement("a");
    downloadLink.href = data?.pdfFileUrl;
    downloadLink.download = data.pdfName || data?.pdfFileName || "pdf_download.pdf";
    downloadLink.click();
  };

  const showPDF = () => {
    if (typeof window === "undefined") return;
    const pdfWindow = window.open("");
    pdfWindow.document.write(
      `<iframe src="${data?.pdfFileUrl}" width="100%" height="100%" style="border: 0"></iframe>`
    );
    pdfWindow.document.body.style.margin = "0px";
  };

  const onOpenPdf = () => {
    if (!data?.pdfFileUrl) return;

    if (isClient() && window.innerWidth < SHOW_MODAL_WIDTH) {
      downloadPDF();
    } else {
      showPDF();
    }
  };

  React.useEffect(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.12.313/pdf.worker.js`;
  }, []);

  return (
    <PreviewLayout
      page="pdf"
      dataQA="preview-pdf-container"
      backgroundColor={data?.themeColor?.backgroundColor}
      includeBrowser
      initPreview={isInitPreview}>
      <Typography
        Tag="p"
        spacing={4}
        classname="body-s u-bold pdf-company-name">
        {data?.companyName}
      </Typography>

      <div className="pdf-content">
        <Typography
          Tag="p"
          spacing={4}
          size="xl"
          classname="u-bold pdf-name">
          {data?.pdfName}
        </Typography>
        <Typography
          Tag="p"
          spacing={4}
          classname="body-s pdf-description">
          {data?.pdfDescription}
        </Typography>
        <div className={`u-card u-spacing-3 pdf-card ${isInitPreview ? "initPreview" : ""}`}>
          {isInitPreview ? (
            <div className="pdf-empty">
              <Lazy placeholderClass="skeleton-placeholder__pdf__image">
                <img
                  src={data?.logoUrl}
                  alt="pdf menu preview"
                />
              </Lazy>
            </div>
          ) : (
            <>
              {data?.pdfFileUrl ? (
                <div style={{ height: "100%", marginBottom: "1rem" }}>
                  <Document
                    className="pdf-box"
                    file={data?.pdfFileUrl}
                    externalLinkTarget="_blank"
                    loading={
                      <div
                        style={{
                          width: "100%",
                          height: "21rem",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "red",
                        }}>
                        <Button
                          to=""
                          icon={<ReactSVG src="/svg/loading-icon.svg" />}
                          tertiary
                          ghost
                          label="loading..."
                          loading
                        />
                      </div>
                    }>
                    <Page
                      pageNumber={1}
                      renderAnnotationLayer={false}
                      renderTextLayer={false}
                    />
                  </Document>
                </div>
              ) : (
                <div className="pdf-empty">
                  <IoImageOutline style={{ color: "white", height: "100%", width: "80%" }} />
                </div>
              )}
            </>
          )}
        </div>
        <Button
          to=""
          className="pdf-see"
          onClick={onOpenPdf}
          label="See PDF"
          buttonColor={data?.themeColor?.buttonColor}
        />
      </div>
      <Typography
        Tag="p"
        spacing={6}
        classname="u-bold body-s pdf-url">
        {data?.websiteUrl && (
          <a
            className="Preview-layout__link"
            href={checkValidURL(data?.websiteUrl)}
            target="_blank"
            rel="noreferrer">
            {formatClientUrl(data?.websiteUrl)}
          </a>
        )}
      </Typography>
    </PreviewLayout>
  );
}
